import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MessageDate from '../../atoms/timeline/MessageDate';
import styled from 'styled-components';
const StyledGroup = styled.div `
    display: flex;
    flex-direction: column;

    + .message-group {
        margin-top: 30px;
    }
`;
const MessageGroup = ({ date, children }) => {
    return (_jsxs(StyledGroup, { className: "message-group", children: [_jsx(MessageDate, { children: date }), children] }));
};
export default MessageGroup;
